module.exports = __webpack_public_path__ + "img/logo_gift_card.e8d45d31.svg";